// src/pages/SakshamShramHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const SakshamShramHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";
  // const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Learning & Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/bluenext");
  };

  const groupNames = [
    { label: "Digital Learning & Income", emoji: "💰" },
    { label: "Skill Development", emoji: "💡" },
    { label: "Profile & Jobs", emoji: "🧑‍💼" },
    { label: "Task & Management", emoji: "🗂️" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Shopping", emoji: "🛍️" },
    { label: "Community & Social", emoji: "🤝" },
    { label: "Wishes & Fun", emoji: "🎬" },
    { label: "Global Jobs for Indians", emoji: "🌍🧢" },
    { label: "Fooding & Lodging", emoji: "🍽️🛏️" },
  ];

  const menuButtons1 = [
    // 💡 💰 DIGITAL LEARNING & INCOME
    { label: "My Immersive Digital Books", emoji: "📚", link: "/bookshelf", group: "Digital Learning & Income" },
    { label: "Monthly Digital Book", emoji: "📖", link: "/bluenext-bookworld", group: "Digital Learning & Income" },
    { label: "ValueShare", emoji: "💵", link: "/orderflow-earning-estimator", group: "Digital Learning & Income" },
    { label: "Shram Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Learning & Income" },
    { label: "Kharcho Jeeto", emoji: "🎁", link: "/kharchojeeto", group: "Digital Learning & Income" },
    { label: "Marksheet Contest", emoji: "📜", link: "/applause-marksheet-contest", group: "Digital Learning & Income" },
    { label: "Rewarding Ads", emoji: "💎", link: "/visigift-home", group: "Digital Learning & Income" },
    { label: "Rewarding Videos", emoji: "🎥💰", link: "/orderflow-spotbuy", group: "Digital Learning & Income" },

    // 💰 Skill Development
    { label: "Learnings", emoji: "📚", link: "/bluenext-bookworld", group: "Skill Development" },
    { label: "Workforce Workshops", emoji: "🎓", link: "/training-workshops", group: "Skill Development" },
    { label: "Workforce Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Skill Development" },
    { label: "My Trainings", emoji: "🎓", link: "/training-list", group: "Skill Development" },
    { label: "My Certificates", emoji: "📜", link: "/my-certificates-others", group: "Skill Development" },
    { label: "Workforce Database", emoji: "💾", link: "/bluenextdb", group: "Skill Development" },
    { label: "Shram Ranking", emoji: "🏆", link: "/sharmsammanscore", group: "Skill Development" },
    { label: "BlueTube", emoji: "▶️", link: "/wtube", group: "Skill Development" },

    // 🗂️ TASK & MANAGEMENT
    { label: "My Daily Life", emoji: "📝", link: "/bluenext-daily", group: "Task & Management" },
    { label: "Diary", emoji: "📔", link: "/mydiary-home", group: "Task & Management" },
    { label: "Health & Wellness", emoji: "❤️", link: "/bluenext-health", group: "Task & Management" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Task & Management" },
    { label: "Goal Board", emoji: "🎯", link: "/bluenext-goalboard", group: "Task & Management" },
    { label: "Kanban", emoji: "📊", link: "/bluenext-kanban", group: "Task & Management" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/bluenext-touchbookplain", group: "Task & Management" },
    { label: "Digital Writing Grid", emoji: "✍️📊", link: "/bluenext-touchbookgrid", group: "Task & Management" },
    { label: "Digital Voice Writing", emoji: "🎙️✍️", link: "/bluenext-voicebook", group: "Task & Management" },

    // 🛍️ SHRAM SHOPPING
    { label: "Clap4Service", emoji: "👏", link: "/clap4service", group: "Shopping" },
    { label: "Personal Shopping", emoji: "👜", link: "/orderflow-home", group: "Shopping" },
    { label: "Family Shopping", emoji: "👪🛒", link: "/orderflow-home", group: "Shopping" },
    { label: "Gift Zone", emoji: "🎁", link: "/giftify", group: "Shopping" },
    { label: "RoomAnywhere", emoji: "🏠", link: "/roomanywhere", group: "Shopping" },
    { label: "ThinkStylus", emoji: "🖊️", link: "/thinkstylus", group: "Shopping" },
    { label: "I Have Product to Sell", emoji: "🙋‍♀️", link: "/mlmproductrequest/add", group: "Shopping" },

    // 🪞 SHELF REFLECTION
    { label: "My Secure Blue Card", emoji: "🛡️", link: `/pub/blue/${userCode}`, group: "Self Reflection" },
    { label: "My Public Blue Card", emoji: "🧢", link: `/pub/blue/${userCode}`, group: "Self Reflection" },
    { label: "My Memories", emoji: "📝", link: "/memories-list", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/focus-timer-home", group: "Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Self Reflection" },
    { label: "AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Self Reflection" },
    { label: "Self Applause", emoji: "👏", link: "/self-applause", group: "Self Reflection" },
    { label: "I Was Appreciated", emoji: "👏", link: "/applause-for-me", group: "Self Reflection" },
    { label: "My Hack", emoji: "🧱", link: "/jugaad", group: "Self Reflection" },

    // 🤝 COMMUNITY & SOCIAL
    { label: "Applause", emoji: "👏", link: "/applause-hub-home", group: "Community & Social" },
    { label: "Green Contribution", emoji: "🌱", link: "/coolearth-home", group: "Community & Social" },
    { label: "Responsible Indian", emoji: "🌏", link: "/rim", group: "Community & Social" },
    { label: "Shram Presentation", emoji: "📊", link: "/visualbrief-home", group: "Community & Social" },
    { label: "Shram Forum", emoji: "🗣️", link: "/povify-home", group: "Community & Social" },
    { label: "Dodger DB", emoji: "📊", link: "/offboarded-home", group: "Community & Social" },
    { label: "Innovations", emoji: "💡", link: "/bluenext-innovationhub", group: "Community & Social" },

    // 🧑‍💼 Profile & Jobs
    { label: "India Jobboard", emoji: "🇮🇳💼", link: "/bluehands-home", group: "Profile & Jobs" },
    { label: "Global Jobboard", emoji: "🌍💼", link: "/bluehands-global", group: "Profile & Jobs" },
    { label: "Employment Assessment", emoji: "🌍💼", link: "/bluehands-assessment", group: "Profile & Jobs" },
    { label: "My QR Code", emoji: "🔳", link: "/contact-genious-myqr", group: "Profile & Jobs" },
    { label: "My Profile", emoji: "🧑‍💼", link: "/myprofile-home", group: "Profile & Jobs" },
    { label: "My Blue Profile", emoji: "🧰", link: "/myprofile-blueprofile", group: "Profile & Jobs" },
    { label: "I Am Available", emoji: "📢", link: "/bluehands-iamavailable", group: "Profile & Jobs" },
    { label: "My Shortlisted Jobs", emoji: "⭐", link: "/bluehands-shortlisted", group: "Profile & Jobs" },
    { label: "Jobs I Applied", emoji: "📨", link: "/bluehands-applied", group: "Profile & Jobs" },
    { label: "My Biodata", emoji: "📄", link: "/bluehands-mybiodata", group: "Profile & Jobs" },
    { label: "My BlueHands", emoji: "🤝", link: "/bluehands-my", group: "Profile & Jobs" },
    { label: "My Attendance", emoji: "🕒", link: "/attendance-list", group: "Profile & Jobs" },
    { label: "My Jobless History", emoji: "📉", link: "/jobless-list", group: "Profile & Jobs" },
    { label: "My Work Diary", emoji: "📔", link: "/myjournal/2", group: "Profile & Jobs" },
    { label: "My Salary & Wages", emoji: "💰", link: "/salary-list", group: "Profile & Jobs" },

    // 🎬 Wishes & Fun
    { label: "ShramikTube", emoji: "▶️", link: "/wtube", group: "Wishes & Fun" },
    { label: "CarDream", emoji: "🚗", link: "/cardream", group: "Wishes & Fun" },
    { label: "Shaadi", emoji: "💍", link: "/shubhvivah", group: "Wishes & Fun" },
    { label: "Honeymoon", emoji: "🏖️", link: "/honeymoonlight", group: "Wishes & Fun" },
    { label: "Children", emoji: "👧👦", link: "", group: "Wishes & Fun" },
    { label: "SpotSnap", emoji: "🖼️", link: "/spotsnap", group: "Wishes & Fun" },
    { label: "Aalu Dalo Sona Nikalo", emoji: "🥔💰", link: "/aaludalosonanikalocomingsoon", group: "Wishes & Fun" },

    // 🌍 Global Jobs for Indians
    { label: "Opportunity for Indians", emoji: "🌍💼", link: "/bluehands-global-opportunity-indians", group: "Global Jobs for Indians" },
    { label: "Global Jobboard - GCC", emoji: "🕌💼", link: "/bluehands-global", group: "Global Jobs for Indians" },
    { label: "Global Jobboard - Others", emoji: "✈️💼", link: "/bluehands-global-others", group: "Global Jobs for Indians" },
    { label: "Overseas Job Consultants", emoji: "🤝🏢", link: "/workbridge", group: "Global Jobs for Indians" },
    { label: "Visa Application", emoji: "🛂", link: "/visaapplication", group: "Global Jobs for Indians" },
    { label: "Visa Service", emoji: "💳", link: "/visaix", group: "Global Jobs for Indians" },

     // 🍽️🛏️🚌 Fooding & Lodging
    { label: "I am Hungry", emoji: "🍽️", link: "/bhojan", group: "Fooding & Lodging" },
    { label: "My Lodging", emoji: "🛏️", link: "/bluehands-lodging", group: "Fooding & Lodging" },
    { label: "Tindi", emoji: "🚗🚌", link: "/tindi", group: "Fooding & Lodging" },

  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-white font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-blue-400">🧢 BlueNext</div>
          <div className="text-[10px] lg:text-sm text-yellow-200">
            SAKSHAM Shram / Workforce: Skilled And Keen Systematic Hands Achieves More!
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-blue-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-sm lg:text-lg text-blue-300 bg-blue-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-blue-300 text-xs font-medium whitespace-nowrap h-7">
                {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-blue-900/40 text-white text-xs sm:text-sm py-2 mt-2">
        <div className="mx-auto px-3 flex flex-wrap justify-center gap-2 text-xs lg:text-sm">
          <a href="/sakshamshram-insights" className="hover:text-yellow-200">💭 About</a>
          <a href="/litenshort" className="hover:text-yellow-200">💰 Earn Extra</a>
          <a href="/bluenext-updates" className="hover:text-yellow-200">📊 Updates</a>
          <a href="/sakshamshram-faq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
        <div className="text-xs lg:text-sm text-center my-1 mx-1 mt-2  text-blue-200/90">
           Extending Digital Empowerment for Blue Collar Literacy, Productivity and Growth!
        </div>
        <div className="mt-3 flex flex-wrap justify-center gap-3 text-xs lg:text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-xs lg:text-sm">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>        
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-blue-700">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-blue-700 text-yellow-200 shadow-md"
                  : "bg-blue-800 text-blue-100 hover:bg-blue-900"
              }`}
            >
              <span className="text-sm lg:text-lg">{group.emoji}</span>
              <span className="mt-1 text-xs lg:text-sm text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-blue-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-xs lg:text-sm font-medium transition bg-transparent hover:bg-blue-700 hover:text-yellow-200 text-blue-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-sm lg:text-lg">{btn.emoji}</span>
                <span className="mt-1 text-xs lg:text-sm">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-800 text-blue-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default SakshamShramHome;
